import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "items";
// initial state
const state = () => ({
  all: [],
  items: [],
  item: {},
  itemTransactions: [],
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getItem: (state) => {
    return state.item;
  },

  getItems: (state) => {
    return state.items;
  },

  getItemTransactions: (state) => state.itemTransactions,

  getSalesTotalQuantity: (state) => {
    if (state.itemTransactions.sales) {
      return state.itemTransactions.sales.reduce(
        (acc, val) => acc + parseFloat(val.quantity),
        0
      );
    } else {
      return 0;
    }
  },

  getPurchaseTotalQuantity: (state) => {
    if (state.itemTransactions.purchases) {
      return state.itemTransactions.purchases.reduce(
        (acc, val) => acc + parseFloat(val.quantity),
        0
      );
    } else {
      return 0;
    }
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let items = response.data;
      commit("setItems", items);
    });
  },

  async getItemsPrices({ commit }) {
    await axios.get(api + "_prices").then((response) => {
      let items = response.data;
      commit("setItemsPrices", items);
    });
  },
  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let item = response.data;
      commit("setItem", item);
    });
  },

  async store({ dispatch }, data) {
    await axios.post(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });
    });
  },

  async storeAndRouteToPurchase({ dispatch }, data) {
    await axios.post(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      let data = response.data.data;
      dispatch("notification/store", { status, message }, { root: true });
      router.push({
        name: "purchases-items-create",
        query: { item_reference: data.reference },
      });
    });
  },

  async storePrice({ commit, dispatch }, data) {
    await axios.post(api + "_prices", data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("setItemsPrices", response.data.data);
      }
    });
  },

  async update({ dispatch }, data) {
    await axios
      .post(api + "/" + data.get("reference"), data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;
        dispatch("notification/store", { status, message }, { root: true });

        if (status == "success") {
          router.push({
            name: "items-index",
          });
        }
      });
  },

  async destroy({ commit, dispatch }, reference) {
    await axios.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        let items = response.data.data;
        commit("setItems", items);
      }
    });
  },

  async printAll({ dispatch }) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .get(api + "_print", {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Catalogue.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async fetchItemTransactions({ commit }, data) {
    try {
      const response = await axios.post(api + "_transactions", data);

      commit("setItemTransactions", response.data);
    } catch (error) {
      console.error("Error fetching item transactions:", error);
      commit("setItemTransactions", []);
    }
  },
};

// mutations
const mutations = {
  setItems(state, items) {
    state.all = items;
    state.items = items;
  },

  setItemTransactions(state, items) {
    state.all = items;
    state.itemTransactions = items;
  },
  setItemsPrices(state, items) {
    state.all = items;
    state.items = items;
  },
  setItem(state, item) {
    state.item = item;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.items = state.all.filter(function (item) {
      return (
        item.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        item.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
